import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';

// Components
import Reminder from './Reminder';

// Selectors
import { getSelfCheckInFlow } from 'store/reducers/selfCheckIn/selectors';

const mapStateToProps = state => ({
  selfCheckInFlow: getSelfCheckInFlow(state)
});

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    null
  )
)(Reminder);



// WEBPACK FOOTER //
// ./src/components/pages/SelfCheckIn/ConfirmationPage/components/Reminder/ReminderContainer.js